/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-distracting-elements */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/img/logo-fidelys.jpeg';
import { account_service } from '../../services/account_service';
import swal from 'sweetalert';
const SidebarCompany = () => {
  const navigate = useNavigate();

  // navigation 
  const list_client = () => {
    navigate('/company/list/client');
  };

  const scan_code = () => {
    navigate('/company/scanner');
  };

  const home = () => {
    navigate('/company/dashboad');
  };
  const list_scanhistory = () => {
    navigate('/company/list/scanhistory');
  };
  const profile = () => {
    navigate('/company/profil');
  };

  // get name of connected company 
  const nom = localStorage.getItem("nom")

  // sweet alert of deconnexion 
  const handleLogout = () => {
    swal({
      title: "Déconnection!",
      text: "Êtes-vous sûr de vouloir vous déconnecter ?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          account_service.logout()
          localStorage.removeItem('nom')
          navigate("/auth/loginCompany");
          // swal("Vous avez été  déconnecter!", {
          //   icon: "success",
          // });
        } else {
          return;
        }
      });
  };

  return (
    <div>
      <aside className="main-sidebar hide-sidebar sidebar-dark-primary elevation-4">
        <span className="brand-text font-weight-light link" onClick={home}>
          <img src={logo} alt="Fidelys Logo" className='align-items-center logo-fidelys' />
        </span>
        <div className="sidebar">
          <div className="user-panel mt-1 mb-1 d-flex">
            <div className="info">
              <a onClick={profile} className="d-block link uppercase companyName"><strong>{nom}</strong></a>
            </div>
          </div>
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

              <li className="nav-item has-treeview menu-open">
                <a onClick={home} className="nav-link link active">
                  <i className="nav-icon fas fa-tachometer-alt" />
                  <p>
                    Tabeau de bord
                  </p>
                </a>

              </li>
              <li className="nav-header">GESTION DES CLIENTS</li>
              <li className="nav-item has-treeview">
                <a className="nav-link">
                  <i className="nav-icon fas fa-store" />
                  <p>
                    Clients
                    <i className="right fas fa-angle-left" />
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <a onClick={list_client} className="nav-link link">
                      <i className="fas fa-list nav-icon" />
                      <p>Liste des clients</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a onClick={scan_code} className="nav-link link">
                      <i className="fas fa-qrcode nav-icon" />
                      <p>Scanner le Qr code</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a onClick={list_scanhistory} className="nav-link link">
                      <i className="fas fa-history nav-icon" />
                      <p>Historique du scan</p>
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <a onClick={profile} className="nav-link link">
                  <i className="fas fa-user-circle nav-icon mr-1" />
                  <p>Profil</p>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link link" title='Cliquez pour ce déconnecter' onClick={handleLogout}>
                  <i class="fas fa-sign-out-alt mr-1 nav-icon"></i>
                  <p>
                    Déconnexion
                  </p>
                </a>
              </li>

            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default SidebarCompany;